import "./App.css";
import Header from "./components/Header";
import Members from "./components/Members";

function App() {
  return (
    <div className="App">
      <Header />
      <Members />
    </div>
  );
}

export default App;
